export default "__VITE_PUBLIC_ASSET__8646a457__"